import FbButton from 'components/FbUI/FbButton'
import { default as styled } from 'styled-components'

/**
 * Shared table export/download button. Canonical home for what used to be five
 * identical `styled(FbButton)` copies across the table components. 32px tall to
 * match the compact footer controls — the `IconMiniButton` download on
 * Targets/Campaigns and the pagination Next/Prev buttons.
 *
 * `min-height` must be pinned too: `FbButton`'s default `md` size applies
 * `min-h-10` (35px at the 14px root), which otherwise wins over `height: 32px`
 * (min-height beats height) and silently renders this button 3px too tall.
 */
export const ExportButton = styled(FbButton)`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0 14px;

  gap: 8px;

  height: 32px;
  min-height: 32px;

  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
`
